/** Default frame rate (fps) used when an asset does not specify one. */
export const DEFAULT_FRAME_RATE = 24

/** Milliseconds of inactivity before the player control bar auto-hides. */
export const CONTROL_BAR_AUTO_HIDE_DELAY_MS = 3000

/** Seconds to skip forward or backward when using skip buttons. */
export const PLAYBACK_SKIP_SECONDS = 10

/** Volume range used by the HLS.js player UI (matches Bitmovin's 0–100 scale). */
export const VOLUME_MIN = 0
export const VOLUME_MAX = 100
